import { EcommerceAPI } from "../Client";

export const getDashboardDataAPI = (payload) => {
  return EcommerceAPI.get(
    `/dashboard?year=${payload?.year || ""}&category=${payload?.category || 0}`,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
export const getLastOneYearDashboardDataAPI = (payload) => {
  return EcommerceAPI.get(
    `/dashboard?year=${payload?.year || ""}&category=${payload?.category || 0}`,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
export const getLastTwoYearDashboardDataAPI = (payload) => {
  return EcommerceAPI.get(
    `/dashboard?year=${payload?.year || ""}&category=${payload?.category || 0}`,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDashboardFilterYearAPI = () => {
  return EcommerceAPI.get("/dashboard/filter-year")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDashboardSellerDataAPI = () => {
  return EcommerceAPI.get("/dashboard/seller")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDashboardAdminDataAPI = () => {
  return EcommerceAPI.get("/dashboard/admin")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
